import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, mergeMap, of } from 'rxjs';
import { Auth } from 'src/app/domain/models/auth.model';
import { BaseResponse } from '../../domain/models/base-response.model';
import { IAdapterAuth } from 'src/app/domain/ports/i-adapter-auth';
import { ENVIRONMENT } from 'src/environments/environment';

import { AuthDTO } from '../dto/auth-dto.interface';
import { BaseResponseDTO } from '../dto/base-response-dto.interface';
@Injectable({
  providedIn: 'root'
})
export class AuthAdapterService implements IAdapterAuth{
  private path = ENVIRONMENT.urls.api;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }),
  };

  constructor(private http: HttpClient) {}

  postAuth(userName: string, userPassword: string): Observable<Auth>{
    const url = this.path + '/auth/login';
    const body = {
      "User": userName,
      "Password": userPassword
    }
    return this.http.post<AuthDTO>(url, body, this.httpOptions)
  }

  postForgotPassword(userName: string): Observable<BaseResponse>{
    const url = this.path + '/auth/forgot_password';
    const body = {
      "User": userName
    }
    return this.http.post<BaseResponseDTO>(url, body, this.httpOptions);
  }

  postPasswordRecovery(password: string, confirmPassword: string, token: string): Observable<Auth>{
    const url = this.path + '/auth/reset_password';
    const body = {
      "Password": password,
      "ConfirmPassword": confirmPassword,
      "Token": token
    }
    return this.http.post<AuthDTO>(url, body, this.httpOptions);
  }
}
